import { URLSearchParams } from "url"
import { getDownloadLink } from "../http/http"
import { MDS } from "../http/url"

export const getSearchParams = (): URLSearchParams => {
    return new URL(window.location.href).searchParams
}
export const openIsales = () => {
    const params = getSearchParams()
    const code = params.get('code')
    const pageId = params.get('pageId')
    const data: any = {}
    if (pageId) params.delete('pageId')
    params.forEach((value, key) => {
        data[key] = value
    })
    if (pageId) {
        // const paramToSend = getPlatForm().android ? params.toString() : encodeURIComponent(params.toString())
        // console.log('open path', (`isales://com.taikanglife.isalessystem.test/jump?platform=yes&pageId=${pageId}&param=${encodeURIComponent(params.toString())}`))
        window.location.href = (`isales://com.taikanglife.isalessystem/jump?platform=yes&pageId=${pageId}&param=${encodeURIComponent(params.toString())}`)
    } else {
        window.location.href = (`isales://com.taikanglife.isalessystem/jump?module=${code || '0000'}`)
    }
}


export const downloadAppEvent = (platForm: PlatForm, callback?: Function) => {
    // const params = getSearchParams()
    // const mpaas = params.get('pageId')||params.get('mpaas')
    let url
    const data: { clientType?: string, applicationCode?: string } = { applicationCode:'com.taikanglife.isalessystem' }
    const requestParams: any = { headers: {} }
    // if (mpaas) {
        url = MDS
        data.clientType = platForm.iOS ? 'ios' : platForm.harmony ? 'harmony' :'android'
        requestParams.headers['Content-Type'] = 'application/json'
        requestParams.sendJSON = true
    // } else {
    //     url = ISALESLINKS
    //     data.clientType = platForm.iOS ? 'ios' : 'android'
    // }
    if(data.clientType === 'harmony'){
        window.location.href = 'https://appgallery.huawei.com/app/detail?id=com.taikanglife.isales&channelId=SHARE'
        return
    }

    getDownloadLink(url, {
        body: data,
        method: url.method,
        ...requestParams
    }, (res: any) => {
        console.log(res, res.rspCode)
        if (res.rspCode === '0') {
            typeof callback === 'function' && callback(res.info.url || res.info.downloadUrl)
        }

    })
}

export const download = (url: string) => {
    const down = document.createElement('a')
    down.download = url;
    down.href = url
    down.click();
    down.remove();
}

export const getPlatForm = () => {
    const platFormInfo = {
        iOS: false,
        android: false,
        wechat: false,
        wework: false,
        mpaas: false,
        harmony:false,
        pc: false
    }
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        platFormInfo.iOS = true
    } else if (/(Android)/i.test(navigator.userAgent)) {
        platFormInfo.android = true
        const isHarmonyOS = /OpenHarmony (\d+\.\d+)/.test(navigator.userAgent);
        const harmonyOSVersion = isHarmonyOS ? parseFloat(RegExp.$1) : 0;

        if ((isHarmonyOS && harmonyOSVersion >= 5.0) && /arkweb/i.test(navigator.userAgent)) {
           platFormInfo.harmony = true
        }
    }else {
        const isHarmonyOS = /OpenHarmony (\d+\.\d+)/.test(navigator.userAgent);
        const harmonyOSVersion = isHarmonyOS ? parseFloat(RegExp.$1) : 0;

        if ((isHarmonyOS && harmonyOSVersion >= 5.0) && /arkweb/i.test(navigator.userAgent)) {
           platFormInfo.harmony = true
        }else if(/harmony/i.test(navigator.userAgent)||window.screen.width<=720){
            platFormInfo.android = true
        }
    }

    if (!platFormInfo.iOS && !platFormInfo.android && !platFormInfo.harmony) {
        platFormInfo.pc = true
    }
    if (/micromessenger/i.test(navigator.userAgent)) {
        platFormInfo.wechat = true
    }
    if (/wxwork/i.test(navigator.userAgent)) {
        platFormInfo.wework = true
    }
    if (/mpaas/i.test(navigator.userAgent)) {
        platFormInfo.mpaas = true
    }
    return platFormInfo
}
